import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'actionsContainer',
    'addActionButton',
    'actionItemsContainer'
  ]

  connect() {}

  addAction(event) {
    event.preventDefault()
    const container = this.actionItemsContainerTarget
    const items = container.querySelectorAll('[data-action-target="item"]')
    const idx = items.length
    const div = document.createElement('div')
    div.setAttribute('data-action-target', 'item')
    div.className =
      'grid grid-cols-1 sm:grid-cols-2 gap-4 bg-white border border-gray-200 rounded-lg p-4 mb-2 shadow-sm'
    div.innerHTML = `
      <div class="sm:col-span-2">
        <label class="block text-xs font-medium text-gray-700 mb-1">Label</label>
        <input type="text" name="outcome[configuration][actions][${idx}][label]" placeholder="e.g., Call the Hotline" class="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 placeholder-gray-400 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" />
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">Value (Phone or URL)</label>
        <input type="text" name="outcome[configuration][actions][${idx}][value]" placeholder="e.g., (858) 560-2191 or https://..." class="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 placeholder-gray-400 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" />
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 mb-1">Type</label>
        <select name="outcome[configuration][actions][${idx}][type]" class="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
          <option value="phone">Phone</option>
          <option value="url">URL</option>
        </select>
      </div>
      <div class="sm:col-span-2">
        <label class="block text-xs font-medium text-gray-700 mb-1">Help Text</label>
        <input type="text" name="outcome[configuration][actions][${idx}][help_text]" placeholder="e.g., (Opens in new tab)" class="block w-full rounded-md border border-gray-300 px-3 py-2 text-base text-gray-900 placeholder-gray-400 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" />
      </div>
      <div class="sm:col-span-2 flex justify-end">
        <button type="button" data-action="click->admin--outcome-form#removeAction" class="text-red-600 border border-red-300 rounded px-4 py-2 transition hover:bg-red-50 hover:border-red-500 hover:text-red-700 text-sm font-medium">Delete Action</button>
      </div>`
    container.appendChild(div)
  }

  removeAction(event) {
    event.currentTarget.closest('[data-action-target="item"]').remove()
    this.reindexActions()
  }

  reindexActions() {
    this.actionItemsContainerTarget
      .querySelectorAll('[data-action-target="item"]')
      .forEach((item, idx) => {
        const inputs = item.querySelectorAll('input, select')
        inputs.forEach((input) => {
          const name = input.name
          if (name) {
            input.name = name.replace(/\[actions\]\[\d+\]/, `[actions][${idx}]`)
          }
        })
      })
  }
}
